import React from "react";
import { createTimeLine } from "./createTimeline";

type T = {
  interval: number;
  fromTime: Date;
  toTime: Date;
  formatter: (e: any) => any;
  children(...props: any): JSX.Element;
};

class TimeLine extends React.Component<T> {
  listRef: React.RefObject<any>;

  constructor(props: T) {
    super(props);
    this.listRef = React.createRef();
  }

  getTimeLine() {
    const {
      interval, fromTime, toTime, formatter } = this.props;

    return createTimeLine(
      new Date(fromTime.getTime()),
      new Date(toTime.getTime()),
      interval
    ).map(formatter);
  }

  render() {
    const { children } = this.props;
    return this.getTimeLine().map((t, index, stack) => children(t, index, stack));
  }
}

export default TimeLine;
